<!-- @format -->

<div
	class="hmf-w-100 hmf-display-flex hmf-flex-column hmf-justify-content-between hmf-position-relative gap-xs"
	[class]="isCompact() ? 'compact' : 'full-size'">
	<div
		class="hmf-display-flex hmf-flex-column"
		[class]="isCompact() ? 'gap-xxs' : 'gap-s'">
		<div
			class="product-image-wrapper"
			[class]="isCompact() ? 'shrink' : 'expand'">
			<hmf-skeleton
				[loading]="true"
				width="100%"
				height="100%"
				class="hmf-h-100"></hmf-skeleton>
		</div>

		<div class="details-wrapper hmf-display-flex hmf-flex-column">
			<div class="product-name-section">
				<hmf-skeleton
					[loading]="true"
					width="80%"
					[height]="
						breakpointsService.breakpoint() < BreakPointNew.SMALL ? '12px' : '14px'
					"></hmf-skeleton>
			</div>
			<div class="price-section">
				<hmf-skeleton
					[loading]="true"
					[height]="
						breakpointsService.breakpoint() < BreakPointNew.SMALL && !isCompact()
							? '20px'
							: '16px'
					"
					[width]="
						breakpointsService.breakpoint() < BreakPointNew.SMALL ? '40%' : '20%'
					"></hmf-skeleton>
			</div>
			<div class="hmf-display-flex hmf-pt-xxs">
				@for (star of [0, 0, 0, 0, 0]; track $index) {
					<homefield-icon
						width="16px"
						height="16px"
						name="star-filled-0-percent">
					</homefield-icon>
				}
			</div>
		</div>
	</div>

	<button
		hmf-button
		class="select-options-button hmf-mb-xxs hmf-mb-sm-s"
		[size]="'small'"
		[disabled]="true">
		Select Options
	</button>

	<button
		hmf-button
		class="product-remove-button hmf-position-absolute hmf-p-s"
		aria-hidden="true"
		tabindex="-1"
		[disabled]="true">
		<homefield-icon
			name="delete-filled"
			width="16px"
			height="16px"></homefield-icon>
	</button>
</div>
